import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import type { Section } from '../../../../models';
import { FLOOD_HAZARD } from '../../../../constants';
import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function FloodHazard({ section, setSectionValues }: Props) {
  function onNoFloodZone(): void {
    setSectionValues({
      [FLOOD_HAZARD.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesFloodZone(): void {
    setSectionValues({
      [FLOOD_HAZARD.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      label={
        <Label size="lg">
          Is the property located in a special flood hazard area or an area of potential flooding?
        </Label>
      }
      control={
        <YesAndNo
          yesHandler={onYesFloodZone}
          noHandler={onNoFloodZone}
          yesActive={section.getFieldValue(FLOOD_HAZARD.FIELD_NAME.IS_ENABLED)}
        />
      }
    />
  );
}

FloodHazard.description = 'Asks whether or not the property is in a flood area';

export default FloodHazard;
